import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, takeUntil, tap } from 'rxjs/operators';

import {
  GetEnumValuesDto,
  GetShortLinksWithPaginationDto,
  PaginatedListOfGetShortLinksWithPaginationDto,
} from 'src/app/core/api/models';
import { ShortLinksService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { ShortLinkReportDialogComponent } from './short-link-report/short-link-report-dialog.component';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { ShortLinksFormComponent } from "./short-links-form/short-links-form.component";


@Component({
    selector: 'app-short-links',
    templateUrl: './short-links.component.html',
    imports: [BaseIndexModule, ShortLinksFormComponent]
})
export class ShortLinksComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.shortLinks;

  /* Binding service endpoints */
  protected currentService = inject(ShortLinksService);
  paginationApiMethodName: string = this.currentService.shortLinksGetShortLinksWithPagination.name;
  createGetApiMethodName: string = this.currentService.shortLinksCreateGet.name;
  auditApiMethodName: string = this.currentService.shortLinksGetShortLinksAudit.name;
  /* Binding service endpoints */

  modelWithPagination$: Observable<PaginatedListOfGetShortLinksWithPaginationDto>;
  items$: Observable<Array<GetShortLinksWithPaginationDto>>;
  UrlTypeEnumValues: GetEnumValuesDto[] = [];
  @Input('isShowAuditBtn') input_isShowAuditBtn: boolean = true;
  @Input('isModalMode') input_isModalMode: boolean = false;
  @Input('getTableDataApiMethodName') getTableDataApiMethodName: string =
    'shortLinksGetShortLinksWithPagination';

  @Output('selectedShortLink') output_selectedShortLink =
    new EventEmitter<string>();
  @Output('showDialogTitle') output_showDialogTitle =
    new EventEmitter<boolean>();

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      // this.pageConfig.showAuditBtn = this.input_isShowAuditBtn;
      this.pageConfig.showAuditBtn = false;

      if (this.input_isModalMode) {
        this.pageConfig.loading = true;
        this.pageConfig.showHelpBtn = false;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.contentManagement
      );
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('UrlType')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.UrlTypeEnumValues = values));
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.title, name: 'title', hasSearch: true },
      {
        title: `${this.tableVocabs}urlType`,
        name: 'urlType',
        hasSearch: true,
        type: 'enum',
        enumName: 'UrlType',
      },
      {
        title: `${this.tableVocabs}shortUrl`,
        name: 'shortUrl',
        hasSearch: true,
      },
      { title: `${this.tableVocabs}mainUrl`, name: 'mainUrl', hasSearch: true },
      {
        title: 'common.isActive',
        name: 'isActive',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        type: 'dateTime',
        hasSearch: true,
      },
    ];

    if (this.input_isModalMode) {
      this.tableColumns = this.tableColumns.filter(
        (obj) => obj.name !== 'created' && obj.name !== 'isActive'
      );
      // this.tableColumns.push({noSorting:true});
    }
  }

  setDefaultTableSort() {
    if (this.input_isModalMode)
      this.sortObject.push({ columnName: 'title', sort: 1 });
  }


  //change isActive
  isActiveShortLinkApi(id, isActive) {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .shortLinksUpdateShortLinkIsActive({
        body: { shortLinkId: id, isActive: isActive },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Get report
  shortLinkReportApi(id) {
    this.unSubs();

    this.pageConfig.loading = true;

    this.currentService
      .shortLinksGetShortLinkReport({ ShortLinkId: id })
      .pipe(
        this.basePipeOperators(),
        map((res) => res.data)
      )
      .subscribe(
        (result: string) => {
          if (result) {
            this.unSubs();

            const modalResult = this.dialogService.openModal({
              component: ShortLinkReportDialogComponent,
              data: result,
            });

            modalResult
              .afterClosed()
              .pipe(
                takeUntil(this.onDestroy$),
                tap(() => {
                  AppDomService.removeModalScrollClassFromHtml();
                })
              )
              .subscribe();
          }
        },
        (error) => ConsoleService.error('error', error),
        () => (this.pageConfig.loading = false)
      );
  }
  //#endregion
  onIsActive(id, isActive) {
    this.isActiveShortLinkApi(id, isActive);
  }

  onCreate(type?: any, isFormModal?: boolean) {
    try {
      this.currentService[this.createGetApiMethodName]()
        .pipe(this.basePipeOperators())
        .subscribe(
          (res) => {
            if (res) {
              this.pageConfig.isVisibleForm = true;
              this.output_showDialogTitle.emit(false);
              this.setParentQueryString();
              this.location.go(
                window.location.pathname + '?key-formType=create'
              );
            }
          },
          (error) => {
            this.pageConfig.isVisibleForm = undefined;
            const timeout = setTimeout(() => {
              this.pageConfig.isVisibleForm = false;
              clearTimeout(timeout);
            }, 10);
          }
        );
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.baseIndexPage
      );
    }
  }

  getFormResponse(isSuccess) {
    if (isSuccess) {
      this.getTableData();
      this.selectedIds = [];
    }

    this.pageConfig.isVisibleForm = false;
    this.output_showDialogTitle.emit(true);

    this.unSubs();
  }

  onSelect(shortLink) {
    this.output_selectedShortLink.emit(shortLink);
  }
}
